var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.5,
    height: 48.3,
    viewBox: "0 0 53.5 48.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "events",
    d: "M8.2,43.5v7.8H16V43.5H42v7.8h7.8V35.7H8.2Zm39-20.8H55v7.8H47.2ZM3,22.7h7.8v7.8H3Zm39,7.8H16V9.7a5.215,5.215,0,0,1,5.2-5.2H36.8A5.215,5.215,0,0,1,42,9.7Z",
    transform: "translate(-2.25 -3.75)",
    fill: "none",
    stroke: "#f68f28",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/Event.a094dfe5d04a0f2632f81c5497007766.svg";
export { ForwardRef as ReactComponent };